import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.map.js";
export var GRADING_SCALE_LABEL = 'Grading scale';
export var GRADING_AVERAGE_LABEL = 'Grading average';
var SCALES = Object.freeze(['4', '5', '7', '10', '20', '100']);
export var SCALE_OPTIONS = SCALES.map(function (max) {
  return {
    label: max,
    value: max
  };
});